import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { getFormattedDate } from 'helpers/dates';

import { MysteryShopRequestInbound } from '../types';

const Container = styled.div`
  display: flex;
  flex-flow: column;
`;

const StyledSubTitle = styled(Typography.Text)`
  font-size: 12px;
  min-height: 18px;
  max-height: 36px;
  overflow: hidden;
  color: var(--text-secondary);
`;

type Props = {
  shopRequest: MysteryShopRequestInbound;
};

const ShopRequestsUpdatedAt = ({ shopRequest }: Props) => {
  if (!shopRequest.updated_at) {
    return <div />;
  }

  return (
    <Container className="updated-at-column">
      <Typography.Text>{getFormattedDate(shopRequest.updated_at, 'MMMM D YYYY')}</Typography.Text>
      <StyledSubTitle>
        {shopRequest?.updated_by?.id === shopRequest?.shopper?.userId ? 'Shopper' : shopRequest?.updated_by?.full_name}
      </StyledSubTitle>
    </Container>
  );
};

export default ShopRequestsUpdatedAt;
